export const EIA_REGIONS = {
    NATIONAL_AVERAGE: {
        slug: 'NATIONAL_AVERAGE',
        value: 'EMD_EPD2D_PTE_NUS_DPG',
    },
    EAST_COAST_PADD1: {
        slug: 'EAST_COAST_PADD1',
        value: 'EMD_EPD2D_PTE_R10_DPG',
    },
    NEW_ENGLAND_PADD1A: {
        slug: 'NEW_ENGLAND_PADD1A',
        value: 'EMD_EPD2D_PTE_R1X_DPG',
    },
    CENTRAL_ATLANTIC_PADD1B: {
        slug: 'CENTRAL_ATLANTIC_PADD1B',
        value: 'EMD_EPD2D_PTE_R1Y_DPG',
    },
    LOWER_ATLANTIC_PADD1C: {
        slug: 'LOWER_ATLANTIC_PADD1C',
        value: 'EMD_EPD2D_PTE_R1Z_DPG',
    },
    MIDWEST_PADD2: {
        slug: 'MIDWEST_PADD2',
        value: 'EMD_EPD2D_PTE_R20_DPG',
    },
    GULF_COAST_PADD3: {
        slug: 'GULF_COAST_PADD3',
        value: 'EMD_EPD2D_PTE_R30_DPG',
    },
    ROCKY_MOUNTAIN_PADD4: {
        slug: 'ROCKY_MOUNTAIN_PADD4',
        value: 'EMD_EPD2D_PTE_R40_DPG',
    },
    WEST_COAST_PADD5: {
        slug: 'WEST_COAST_PADD5',
        value: 'EMD_EPD2D_PTE_R50_DPG',
    },
    WEST_COAST_LESS_CALIFORNIA: {
        slug: 'WEST_COAST_LESS_CALIFORNIA',
        value: 'EMD_EPD2D_PTE_R5XCA_DPG',
    },
    CALIFORNIA: {
        slug: 'CALIFORNIA',
        value: 'EMD_EPD2D_PTE_SCA_DPG',
    },
};
